import React from "react";
import {
  FaCoins,
  FaPalette,
  FaDesktop,
  FaShieldAlt,
  FaGlobe,
  FaBolt,
} from "react-icons/fa";

function CustomBranding() {
  return (
    <>
      <div
        className="process-style-two-area overflow-hidden bg-cover default-padding bg-dark text-light"
        style={{
          backgroundImage:
            "url(https://validthemes.net/site-template/robok/assets/img/shape/banner-20.jpg)",
        }}
      >
        <div className="container">
          <div className="site-heading">
            <div className="row align-center">
              <div className="col-lg-8">
                <h4 className="sub-title">Our Process</h4>
                <h2 className="title split-text-right split-text-in-right split-lines">
                  Key Features of our White Label Crypto Wallet
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="process-style-two-items">
            <div className="row">
              <div className="col-lg-4 col-md-6 ">
                <div className="process-style-two-item">
                  <div className="icon pb-10 pt-30" style={{ width: "15%" }}>
                    <FaCoins size={35} />
                  </div>
                  <h4>Multi-Currency Support</h4>
                  <p>
                    Manage a variety of cryptocurrencies like Bitcoin, Ethereum,
                    and stablecoins (USDT, USDC) all in one place.
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 ">
                <div className="process-style-two-item">
                  <div className="icon pb-10 pt-30" style={{ width: "15%" }}>
                    <FaPalette size={35} />
                  </div>
                  <h4>Custom Branding</h4>
                  <p>
                    Tailor the wallet’s appearance to reflect your brand
                    identity with your logo, color schemes, and design elements.
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 ">
                <div className="process-style-two-item">
                  <div className="icon pb-10 pt-30" style={{ width: "15%" }}>
                    <FaDesktop size={35} />
                  </div>
                  <h4>Cross-Platform Access</h4>
                  <p>
                    Available on web, Android, and iOS, ensuring your users can
                    access their assets anytime, anywhere.
                  </p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-4 col-md-6 ">
                <div className="process-style-two-item">
                  <div className="icon pb-10 pt-30" style={{ width: "15%" }}>
                    <FaShieldAlt size={35} />
                  </div>
                  <h4>High-Level Security s</h4>
                  <p>
                    Advanced encryption, two-factor authentication (2FA), and
                    cold storage integration to protect your assets and data.
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 ">
                <div className="process-style-two-item">
                  <div className="icon pb-10 pt-30" style={{ width: "15%" }}>
                    <FaGlobe size={35} />
                  </div>
                  <h4>Integrated DeFi Services</h4>
                  <p>
                    Enable staking, yield farming, and lending directly from the
                    wallet for more user engagement.
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 ">
                <div className="process-style-two-item">
                  <div className="icon pb-10 pt-30" style={{ width: "15%" }}>
                    <FaBolt size={35} />
                  </div>
                  <h4>Quick Integrations</h4>
                  <p>
                    Add new tokens and blockchain networks quickly by simply
                    adding logos and chain integration data.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CustomBranding;
